import UserService from "../services/UserService"
import { useNavigate } from 'react-router-dom'

function Profile() {
	const navigate = useNavigate();
	const logout = () => {
		UserService.logout();
		navigate("/");
	}
	const back = () => {
		navigate("/");
	}	
	return (
		<div className="Profile">
			<div className="p-3">

				<div style={{float:"left"}} onClick={back}>
					<svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
						<path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
					</svg>
				</div>
	
				<div className="text-center">
					<h5>Perfil</h5>
				</div>
				
			</div>
			
			<div className="d-inline-block border rounded p-4">
				<svg xmlns="http://www.w3.org/2000/svg" width="3em" height="3em" fill="currentColor" className="bi bi-person" viewBox="0 0 16 16">
					<path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z"/>
				</svg>
			</div>
			
			<p className="py-4">Vito Perricone Alcal&aacute;</p>
			
			<div className="btn btn-primary text-white rounded-pill">Actualiza tu perfil</div>
			<p className="text-small" style={{marginTop: "300px"}}>
				Versi&oacute;n 1.0.0<br />
				Hecho en Venezuela
			</p>
			<div className="text-primary mt-4 mb-4 text-small" onClick={logout}>CERRAR SESI&Oacute;N</div>
		</div>
	);
}

export default Profile;